// extracted by mini-css-extract-plugin
export default {"container":"Card_container__Q7Kcn","body":"Card_body__JioiZ","readMore":"Card_readMore__rZqil","trash":"Card_trash__clkp5"};